import { reportingService } from "fleet/service/reporting";
import { createApiSaga } from "redux-store/api-sagas";

import {
  FETCH_AD_DELIVERY_REPORT,
  FETCH_AD_DELIVERY_REPORT_SUCCESS,
} from "./actions";

const adDeliveryReportSaga = createApiSaga({
  service: reportingService.adDelivery,
  serviceName: "reportingService.adDelivery",
  fetchAction: FETCH_AD_DELIVERY_REPORT,
  successAction: FETCH_AD_DELIVERY_REPORT_SUCCESS,
});

export { adDeliveryReportSaga };
